import { useState } from 'react';

import { useGetShortLink } from '@kiki/f2e.hooks.use-get-short-link';
import { I18n } from '@utils/index';
import { openShareModal } from '@widget/airdrop/Modal/ShareModal';
// import config from '@utils/config';
interface ShareProps {
  /** HTML挂载节点 */
  el: HTMLElement,
  /** 过期时间 */
  expiredTime: number,
  /** 空投总份数 */
  num: number,
  /** 空投已领份数 */
  receiveNum: number,
  /** 昵称 */
  nickName: string,
  /** 空投类型 */
  assignType: string,
  /** 空投id */
  id: string,
  /** 祝福语 */
  greeting: string
}

const airdropType = () => ({
  FORTUNE: I18n.t('tnZ3Gs8U'),
  GENERAL: I18n.t('UQwkViPO')
})

export const useShare = () => {
  const [isLoading, setIsLoading] = useState(false);
  const getShortLink = useGetShortLink();
  const shareOpen = async (props: ShareProps) => {
    const { el, expiredTime, num, receiveNum, nickName, assignType, greeting } = props;
    setIsLoading(true);
    console.log('props11111', props);
    const link = await getShortLink({
      origin: `${origin}/${I18n.locale}/airdrop/${encodeURIComponent(props.id)}?locale=${I18n.locale}`,
      paramsRetainArr: ['id', 'locale']
    })
    setIsLoading(false);
    openShareModal({
      el: el,
      endTime: Number(expiredTime) / 1000,
      allCount: num,
      shareCount: receiveNum,
      shareLink: link,
      title: I18n.t('GIqmGwOC', { nickname: nickName, type: airdropType()[assignType] }),
      greeting: greeting
    })
  }
  return { isLoading, shareOpen };
};
